/* eslint-disable consistent-return */
import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import PropTypes from 'prop-types';

import {
  Alert, AlertTitle, Collapse, Grow, IconButton,
} from '@mui/material';

import { Close, InfoOutlined } from '@mui/icons-material';

import { useSystemNotificationsContext } from './context';

const TIMEOUT = 300;
const DURATION = 15000;

export const SnackbarToast = ({ toast }) => {
  const [open, setOpen] = useState(true);
  const { removeToast } = useSystemNotificationsContext();

  const timerAutoHide = useRef();

  const close = useCallback(() => {
    setOpen(false);

    setTimeout(() => removeToast(toast.key), TIMEOUT);
  }, [toast.key, removeToast]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    toast.onClose?.();
    close();
  };

  useEffect(() => {
    if (open && toast.duration) {
      timerAutoHide.current = setTimeout(() => close(), toast.duration || DURATION);
    }

    return () => {
      if (timerAutoHide.current) {
        clearTimeout(timerAutoHide.current);
      }
    };
  }, [open, toast.duration]);

  const action = (
    <IconButton
      aria-label="close"
      color="inherit"
      size="small"
      onClick={handleClose}
    >
      <Close fontSize="inherit" />
    </IconButton>
  );

  return (
    <Collapse in={open} timeout={TIMEOUT} unmountOnExit>
      <Grow appear={false} in={open} timeout={TIMEOUT / 2} unmountOnExit>
        <Alert
          key={toast.key}
          severity={toast?.severity || 'warning'}
          icon={toast?.icon}
          iconMapping={{
            warning: <InfoOutlined fontSize="inherit" />,
          }}
          action={action}
          variant="filled"
        >
          {toast?.title && <AlertTitle>{toast.title}</AlertTitle>}
          {toast?.message}
          {toast?.children}
        </Alert>
      </Grow>
    </Collapse>
  );
};

SnackbarToast.propTypes = {
  toast: PropTypes.object.isRequired,
};
